module.exports = __webpack_public_path__ + "img/lens-174-plus-08.dbeb9406.png";